import { startApp } from '../start'

startApp()
